import { render, staticRenderFns } from "./G-1-1b-5__SupportEdit_B2C_TechnicalSupports.vue?vue&type=template&id=30f4b055&"
import script from "./G-1-1b-5__SupportEdit_B2C_TechnicalSupports.vue?vue&type=script&lang=js&"
export * from "./G-1-1b-5__SupportEdit_B2C_TechnicalSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
